<template>
  <div>
    <div class="d-flex soundlab__title">
      <transition name="fade" mode="out-in">
        <div v-if="language === 'HU'" key="about-hu" class="d-flex">
          <p class="font__futura-pt-bold">SOUNDLAB</p>
        </div>

        <div v-if="language === 'EN'" key="about-en" class="d-flex">
          <p class="font__futura-pt-bold">SOUNDLAB</p>
        </div>
      </transition>
      <!--          <p class="font__futura-pt-bold">THE HUB</p>-->
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="language === 'HU'" key="soundlab-hu" class="texts">
        <p class="font__futura-book-std text">
          Az ASAN Budapest központi helyszínén tudunk neked segíteni abban, hogy találj megfelelõ zenét promóciós és mûvészeti céljaidhoz, a podcastod vagy mood videód hangulatához. Segíthetünk hogy dalaid jobban szóljanak, és hangzásuk optimalizálva legyen a stream felületekhez. Ha arculati vagy grafikai tervezésre vágysz, abban is tudunk segíteni.
        </p>
        <p class="font__futura-std-heavy">
          Teljes hang- és zenei produkciós szolgáltatásunk elérhetõ B2B és egyéb kereskedelmi célokra.
        </p>
        <p class="font__futura-std-heavy">
          Elérhetõ audio szolgáltatások:
        </p>
        <p class="font__futura-book-std list text">
          -&emsp; Alkalmazott zeneszerzés
          <br/>
          -&emsp; Hangvágás
          <br/>
          -&emsp; Keverés
          <br/>
          -&emsp; Mastering
          <br/>
          -&emsp; Egyéb háttérzenei tartalmak készítése, testreszabása
          <br/>
          -&emsp; Podcast rögzítése és utómunka
        </p>
        <p class="font__futura-std-heavy">
          Filmekhez, egyéb mozgóképhez:
        </p>
        <p class="font__futura-book-std list text">
          -&emsp; Foley
          <br/>
          -&emsp; Sound Design
          <br/>
          -&emsp; Voice Over / Narráció felvétel és keverés
          <br/>
          -&emsp; Dolby 5.1 – 7.1 keverés
        </p>
      </div>

      <div v-if="language === 'EN'" key="soundlab-en" class="texts">
        <p class="font__futura-book-std text">
          The production service can help you to find the best music for your ads, podcasts, mood videos and for any other custom use. We can help enhance your music, and assist with optimizing it for streaming platforms. The soundlab is an isolated space where you can record your podcast or have our engineers mix and master your music.
          We can help with branding, design, and artwork also.
        </p>
        <p class="font__futura-std-heavy">
          Full sound production service available for advertising and B2B commercial sync.
        </p>
        <p class="font__futura-std-heavy">
          Available Audio Services:
        </p>
        <p class="font__futura-book-std list text">
          -&emsp; Custom Music Production
          <br/>
          -&emsp; Sound Editing
          <br/>
          -&emsp; Mixing
          <br/>
          -&emsp; Mastering
          <br/>
          -&emsp; Full Sound Production
          <br/>
          -&emsp; Final exports for stream, TV
        </p>
        <p class="font__futura-std-heavy">
          For films and motion pictures:
        </p>
        <p class="font__futura-book-std list text">
          -&emsp; Sound Design
          <br/>
          -&emsp; Foley
          <br/>
          -&emsp; Voice Over
          <br/>
          -&emsp; Dolby Digital mixing (5.1- 7.1)
        </p>
      </div>

    </transition>
<!--    <img src="../assets/img/ASAN_02d.png" alt="about02dd"/>-->
<!--    <img src="../assets/img/ASAN_03.png" alt="about033"/>-->
    <img src="../assets/img/ASAN_04.png" alt="about044"/>
    <img src="../assets/img/ASAN_05.png" alt="about055"/>
    <img id="singleimage" src="../assets/img/ASAN_06.png" alt="about066"/>
  </div>
</template>

<script>
export default {
  name: "About",
  computed: {
    language: function () {
      return this.$store.getters.language;
    }
  },
}
</script>

<style scoped>
  .font__futura-std-heavy{
    line-height: 18pt;
    letter-spacing: 1px;
    font-size: 9pt;
    color: var(--asan-dark-grey)
  }
  .font__futura-book-std{
    letter-spacing: 1px;
    line-height: 18pt;
    font-size: 9pt;
    color: var(--asan-dark-grey)
  }
  .font__futura-pt-bold{
    font-size: 18pt;
    letter-spacing: 2px;
  }

.soundlab__title p{
  font-size: 14pt;
  margin-top: 20px;
  margin-bottom: 20px;
}
img{
  width: 100%;
  margin-top: 20px;
}
</style>